module.exports = __webpack_public_path__ + "img/new_banner.6eea8abb.jpg";